var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { bindable } from "aurelia-templating";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { EntityTypeConfigurationHelper } from "../../../models/basics/basics.models";
import { QueriesClientService } from "../../../services/queries/queries-client.services";
import * as Enumerable from "linq";
import { Messages } from "../../../configuration/event-messages.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";
import { StringUtilities } from "../../../utilities/strings";
import { Router } from "aurelia-router";
import { UserClaimsService } from "../../../services/authentication/user-claims.service";
var dropdown = require("./entity-finder-dropdown.html");
var EntityFinderSearch = /** @class */ (function () {
    function EntityFinderSearch(dialogService, element, router, eventAggrigator, queryService, userCliamsService, entityTypeConfigurationHelper) {
        this.dialogService = dialogService;
        this.element = element;
        this.router = router;
        this.eventAggrigator = eventAggrigator;
        this.queryService = queryService;
        this.userCliamsService = userCliamsService;
        this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        this.autoSelectResult = true;
        this.placeholder = "";
        this.showOnAdorner = true;
        this.selectedEntity = null;
        this.info = "";
        this.supportedEntityTypes = [];
        this.checkForPermission = true;
        this.results = {};
        this.currentSelection = null;
        this.items = [];
        this.currentItem = null;
        this.lengthBeforeSelection = 0;
        this.menuResults = [];
        this.currentContext = this;
        this.eventAggrigator.subscribe(Messages.documentClick, this.closePopup.bind(this));
    }
    EntityFinderSearch.prototype.createNewClick = function () {
        var paramsEvent = { detail: this.filter, bubbles: true };
        var changeTextEvent = new CustomEvent("create-new-click", paramsEvent);
        this.element.dispatchEvent(changeTextEvent);
        this.closePopup();
    };
    EntityFinderSearch.prototype.attached = function () {
        this.dropdown = dropdown;
    };
    EntityFinderSearch.prototype.stopPropagation = function (e) {
        e.stopPropagation();
    };
    EntityFinderSearch.prototype.closePopup = function () {
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
        if (!window["SystemJS"]) {
            require("" + "../../components/entity-finder/entity-finder");
        }
        this.isVisible = false;
    };
    EntityFinderSearch.prototype.onSubmit = function () {
        this.dialogService.show(DialogServiceConstants.URLs.EntityFinderModal, this);
    };
    EntityFinderSearch.prototype.set = function (x) {
        var _this = this;
        this.get(x).then(function (a) {
            _this.selectedEntityUri = x.entityTypeUri;
            _this.selectedEntity = a;
            _this.filter = _this.asString(_this.selectedEntityUri, _this.selectedEntity);
        });
    };
    EntityFinderSearch.prototype.selectedEntityChanged = function (newValue, oldValue) {
        if (newValue == null) {
            this.filter = null;
        }
    };
    EntityFinderSearch.prototype.selectEntity = function (entity, entityTypeUri, hideDropdown, looseFocus) {
        var _this = this;
        if (hideDropdown === void 0) { hideDropdown = true; }
        if (looseFocus === void 0) { looseFocus = false; }
        if (this.allowSelection) {
            this.currentItem = { entityTypeUri: entityTypeUri, value: entity };
            this.currentSelection = entity;
            this.selectedEntity = entity ? this.normalizeModel(entity) : null;
            this.selectedEntityUri = entityTypeUri;
            var asString_1 = this.asString(entityTypeUri, this.selectedEntity);
            if (this.dialogService.isModalVisible && this.dialogService.view == DialogServiceConstants.URLs.EntityFinderModal) {
                this.dialogService.hide();
            }
            if (hideDropdown) {
                this.isVisible = false;
            }
            if (looseFocus) {
                setTimeout(function () {
                    _this.input.blur();
                    _this.filter = asString_1 && asString_1.indexOf("undefined") == -1 ? asString_1 : "";
                });
            }
            else {
                setTimeout(function () {
                    _this.filter = asString_1 && asString_1.indexOf("undefined") == -1 ? asString_1 : "";
                });
            }
            this.element.dispatchEvent(new CustomEvent("item-selected", {
                bubbles: true,
                detail: { selectedEntity: this.selectedEntity, selectedEntityUri: this.selectedEntityUri }
            }));
        }
    };
    EntityFinderSearch.prototype.selectMenuItem = function (menuItem) {
        var _this = this;
        if (this.dialogService.isModalVisible && this.dialogService.view == DialogServiceConstants.URLs.EntityFinderModal) {
            this.dialogService.hide();
        }
        this.isVisible = false;
        setTimeout(function () {
            _this.input.blur();
            _this.filter = "";
        });
        this.router.navigateToRoute(menuItem.route);
    };
    EntityFinderSearch.prototype.normalizeModel = function (entity) {
        var e_1, _a;
        var obj = {};
        try {
            for (var _b = __values(Object.keys(entity)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                obj[StringUtilities.camelize(key)] = entity[key].value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return obj;
    };
    EntityFinderSearch.prototype.setFirst = function (filter, supportedEntityTypes) {
        var _this = this;
        this.filter = filter;
        return new Promise(function (resolve, reject) {
            _this.search(supportedEntityTypes).then(function (x) {
                _this.items = Enumerable.from(x).orderBy(function (x) { return x.entityTypeUri; })
                    .selectMany(function (x) {
                    var item = Enumerable.from(x.response["value"]).select(function (a) { return ({
                        entityTypeUri: x.entityTypeUri,
                        value: a
                    }); }).toArray();
                    return item;
                }).toArray();
                var filtered = Enumerable.from(_this.items);
                _this.currentItem = filtered.firstOrDefault();
                _this.selectEntity(_this.currentItem.value, _this.currentItem.entityTypeUri, true, true);
                resolve();
            });
        });
    };
    EntityFinderSearch.prototype.setFirstSecurity = function (filter, supportedEntityTypes) {
        var _this = this;
        this.filter = filter;
        return new Promise(function (resolve, reject) {
            _this.search(supportedEntityTypes).then(function (x) {
                _this.items = Enumerable.from(x).orderBy(function (x) { return x.entityTypeUri; })
                    .selectMany(function (x) {
                    var item = Enumerable.from(x.response["value"]).select(function (a) { return ({
                        entityTypeUri: x.entityTypeUri,
                        value: a
                    }); }).toArray();
                    return item;
                }).toArray();
                var filtered = Enumerable.from(_this.items);
                _this.currentItem = filtered.firstOrDefault(function (x) { return x.value.securityId.value == filter; });
                _this.selectEntity(_this.currentItem.value, _this.currentItem.entityTypeUri, true, true);
                resolve();
            });
        });
    };
    EntityFinderSearch.any = function (queryService, filter, bag, supportedEntityTypes) {
        return new Promise(function (resolve, reject) {
            var e_2, _a;
            var promises = [];
            var types = supportedEntityTypes.filter(function (x) { return x.uri != null; });
            var _loop_1 = function (x) {
                var promise = new Promise(function (resolve, reject) {
                    var uri = "/odata/" + (x.uri.replace(/\s/g, "")) + "/Genesis.EntityFinderWithBag(filter='" + filter + "', bag='" + bag + "')";
                    queryService.getData(uri)
                        .then(function (response) {
                        resolve({ entityTypeUri: x.uri, response: response });
                    });
                });
                promises.push(promise);
            };
            try {
                for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
                    var x = types_1_1.value;
                    _loop_1(x);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var all = Promise.all(promises);
            all.then(function (x) {
                var items = Enumerable.from(x).orderBy(function (x) { return x.entityTypeUri; })
                    .selectMany(function (x) {
                    var item = Enumerable.from(x.response["value"]).select(function (a) { return ({
                        entityTypeUri: x.entityTypeUri,
                        value: a
                    }); }).toArray();
                    return item;
                }).toArray();
                var filtered = Enumerable.from(items);
                resolve(filtered.any());
            });
        });
    };
    EntityFinderSearch.prototype.get = function (selectedEntity) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var entity = _this.entityTypeConfigurationHelper.getConfiguration([selectedEntity.entityTypeUri], _this.supportedEntityTypes)[0];
            var entityWithPerm = _this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions([selectedEntity.entityTypeUri], _this.supportedEntityTypes)[0];
            var typeFound = _this.checkForPermission && entity ? entity.uri : (entityWithPerm ? entityWithPerm.uri : null);
            if (typeFound && selectedEntity && selectedEntity.id) {
                var uri = "/odata/" + (typeFound.replace(/\s/g, "")) +
                    "/Genesis.FindIdWithBag(filter='" + selectedEntity.id + "',bag ='" + _this.bag + "')";
                _this.queryService.getData(uri)
                    .then(function (response) {
                    var firstOrDefault = Enumerable.from(response.value)
                        .firstOrDefault(function (a) { return a.id.value == selectedEntity.id; });
                    resolve(_this.normalizeModel(firstOrDefault ? firstOrDefault : {}));
                });
            }
            else {
                resolve(undefined);
            }
        });
        return promise;
    };
    EntityFinderSearch.prototype.getKeys = function (obj, visibleOnly) {
        if (visibleOnly === void 0) { visibleOnly = false; }
        if (visibleOnly) {
            return Enumerable.from(Object.keys(obj)).where(function (a) { return obj[a].isVisible; }).toArray();
        }
        return Object.keys(obj);
    };
    EntityFinderSearch.prototype.search = function (supportedEntityTypes) {
        var e_3, _a;
        var _this = this;
        if (supportedEntityTypes === void 0) { supportedEntityTypes = null; }
        var promises = [];
        var results = {};
        this.results = {};
        var types = supportedEntityTypes ? supportedEntityTypes : this.supportedEntityTypes;
        var _loop_2 = function (x) {
            var promise = new Promise(function (resolve, reject) {
                var uri = "/odata/" + (x.uri ? x.uri.replace(/\s/g, "") : x.uri.replace(/\s/g, "")) + "/Genesis.EntityFinderWithBag(filter='" + _this.filter + "',bag='" + _this.bag + "')";
                _this.queryService.getData(uri)
                    .then(function (response) {
                    resolve({ entityTypeUri: x.uri, response: response });
                });
            });
            promises.push(promise);
        };
        try {
            for (var _b = __values(types.filter(function (x) { return x.uri != null; })), _c = _b.next(); !_c.done; _c = _b.next()) {
                var x = _c.value;
                _loop_2(x);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var all = Promise.all(promises);
        all.then(function (x) {
            var e_4, _a;
            var items = Enumerable.from(x).orderBy(function (x) { return x.entityTypeUri; }).toArray();
            try {
                for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                    var item = items_1_1.value;
                    results[item.entityTypeUri] = item.response;
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            if (_this.onResultsChanged)
                _this.results = _this.onResultsChanged(results).then(function (a) {
                    _this.results = a;
                }, function () {
                    _this.results = results;
                    _this.searchInMenu();
                });
            else
                _this.results = results;
            _this.searchInMenu();
        });
        return all;
    };
    EntityFinderSearch.prototype.searchInMenu = function () {
        var _this = this;
        this.menuResults = [];
        if (this.menuToInclude) {
            this.menuToInclude.forEach(function (menu) {
                if (menu.title.toString().toLocaleLowerCase().indexOf(_this.filter.toLocaleLowerCase()) > -1) {
                    var item = menu.routes.filter(function (route) {
                        var claims = [];
                        if (route && typeof route.claimsRequired == "function") {
                            claims = route.claimsRequired();
                        }
                        else if (route && typeof route.claimsRequired != "function") {
                            claims = route.claimsRequired;
                        }
                        return _this.userCliamsService.hasPermissions(claims);
                    })[0];
                    if (item) {
                        var foundItem = { title: item.title, route: item.name };
                        _this.menuResults.push(foundItem);
                    }
                }
                menu.routes.filter(function (z) { return _this.menuResults.every(function (res) { return res.title != z.title; }); }).forEach(function (route) {
                    var claims = [];
                    if (route && typeof route.claimsRequired == "function") {
                        claims = route.claimsRequired();
                    }
                    else if (route && typeof route.claimsRequired != "function") {
                        claims = route.claimsRequired;
                    }
                    if (route.title.toString().toLocaleLowerCase().indexOf(_this.filter.toLocaleLowerCase()) > -1) {
                        if (_this.userCliamsService.hasPermissions(claims)) {
                            var foundItem = { title: route.title, route: route.name };
                            _this.menuResults.push(foundItem);
                        }
                    }
                });
            });
        }
    };
    EntityFinderSearch.prototype.keyDown = function (e) {
        var _this = this;
        var index = Enumerable.from(this.items).select(function (x) { return JSON.stringify(x); }).toArray()
            .indexOf(JSON.stringify(this.currentItem));
        if (e.keyCode === 40) // down
         {
            index = Math.min(index + 1, this.items.length - 1);
        }
        else if (e.keyCode === 38) // up
         {
            index = Math.max(index - 1, 0);
        }
        else if (e.keyCode === 13) // enter
         {
            if (this.currentItem) {
                this.selectEntity(this.currentItem.value, this.currentItem.entityTypeUri, true, true);
            }
            return false;
        }
        if (e.keyCode == 40 || e.keyCode == 38) {
            this.currentItem = this.items[index];
            setTimeout(function () {
                var scrollViewerJQuery = $(".entity-finder-dropdown.visible");
                var scrollViewer = scrollViewerJQuery.get(0);
                var ele = $(_this.scrollForm).find(".selected")[0] ? $(_this.scrollForm).find(".selected")[0] : scrollViewerJQuery.find(".selected")[0];
                scrollViewer.scrollTop += ele.getBoundingClientRect().top - scrollViewer.getBoundingClientRect().top;
            });
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
        return true;
    };
    EntityFinderSearch.prototype.mouseover = function (index, uri) {
        this.currentMenuRoute = null;
        this.currentItem = Enumerable.from(this.items).where(function (x) { return x.entityTypeUri == uri; }).toArray()[index];
    };
    EntityFinderSearch.prototype.mouseoverMenu = function (index) {
        this.currentItem = null;
        this.currentMenuRoute = this.menuResults[index];
    };
    EntityFinderSearch.prototype.textChanged = function () {
        var _this = this;
        this.isVisible = true;
        if (this.filter) {
            this.search().then(function (x) {
                _this.items = Enumerable.from(x).orderBy(function (x) { return x.entityTypeUri; })
                    .selectMany(function (x) {
                    var item = Enumerable.from(x.response["value"]).select(function (a) { return ({
                        entityTypeUri: x.entityTypeUri,
                        value: a
                    }); }).toArray();
                    return item;
                }).toArray();
                var filtered = Enumerable.from(_this.items);
                // if there is only one result select it
                if (_this.autoSelectResult) {
                    _this.currentItem = filtered.firstOrDefault();
                }
            });
        }
        else {
            this.items = [];
            this.selectEntity(null, null);
        }
    };
    EntityFinderSearch.prototype.entityTypeName = function (uri) {
        var entityTypeName = Enumerable.from(this.supportedEntityTypes).firstOrDefault(function (y) { return y.uri == uri; });
        return entityTypeName.uri;
    };
    EntityFinderSearch.prototype.asString = function (uri, value, shouldNormalize) {
        if (shouldNormalize === void 0) { shouldNormalize = false; }
        if (!uri && !value) {
            return null;
        }
        var config = Enumerable.from(this.supportedEntityTypes).firstOrDefault(function (x) { return x.uri == uri; });
        var format = this.format;
        var params = this.params ? this.params.split(',') : null;
        var item = shouldNormalize ? this.normalizeModel(value) : value;
        if (!item) {
            return "";
        }
        if (config && (!this.format || this.format == "")) {
            if (config.format && typeof config.format === "string") {
                format = config.format;
            }
            else if (config.format && typeof config.format === "function") {
                format = config.format(item);
            }
            else {
                format = "{0}";
            }
        }
        if (config && config.properties && (!this.params || this.params == "")) {
            params = config.properties.split(',');
        }
        if (params) {
            for (var i = 0; i < params.length; i++) {
                var index = "{" + i + "}";
                var regex = new RegExp(StringUtilities.escapeRegExp(index), 'g');
                var str = item[params[i]];
                format = format.replace(regex, str ? str : "");
            }
        }
        return this.decode(item && Object.keys(item).length !== 0 ? format : "");
    };
    EntityFinderSearch.prototype.decode = function (text) {
        var decoded = $('<div/>').html(text).text();
        return decoded;
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "autoSelectResult", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "showOnAdorner", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "allowSelection", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], EntityFinderSearch.prototype, "selectedEntity", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "selectedEntityUri", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], EntityFinderSearch.prototype, "menuToInclude", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "filter", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "bag", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "format", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "params", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "displayMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], EntityFinderSearch.prototype, "supportedEntityTypes", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "checkForPermission", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinderSearch.prototype, "hasCreateNew", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinderSearch.prototype, "createNewText", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], EntityFinderSearch.prototype, "tab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], EntityFinderSearch.prototype, "onResultsChanged", void 0);
    EntityFinderSearch = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [DialogClientService,
            Element,
            Router,
            EventAggregator,
            QueriesClientService,
            UserClaimsService,
            EntityTypeConfigurationHelper])
    ], EntityFinderSearch);
    return EntityFinderSearch;
}());
export { EntityFinderSearch };
